import React, { useState } from "react";

export default useWindowDrag;

function useWindowDrag() {
   const [offset, setOffset] = useState({ x: 0, y: 0 });

   function onTitleBarPointerDown(event: React.PointerEvent) {
      const pointerStartX = event.clientX;
      const pointerStartY = event.clientY;
      const offsetAtStart = offset;

      function onPointerMove(moveEvent: PointerEvent) {
         setOffset({
            x: offsetAtStart.x + moveEvent.clientX - pointerStartX,
            y: offsetAtStart.y + moveEvent.clientY - pointerStartY,
         });
      }

      function onPointerUp() {
         window.removeEventListener("pointermove", onPointerMove);
         window.removeEventListener("pointerup", onPointerUp);
      }

      window.addEventListener("pointermove", onPointerMove);
      window.addEventListener("pointerup", onPointerUp);
   }

   const dragStyle = { transform: `translate(${offset.x}px, ${offset.y}px)` };

   return { dragStyle, onTitleBarPointerDown };
}
